<template>
  <div class="container">
    <img :src="href" alt="" class="href">
    <img :src="changan" alt="" class="icon">
    <p>长按识别二维码跳转至公众号</p>
  </div>
</template>
<script>
import { oaBind } from '@/apis/gameJump';
import { CDN_URL_1 } from '@/config';

export default {
  data() {
    return {
      href: '',
      changan: `${CDN_URL_1}/game_jump/changan.png?v=1`
    };
  },
  mounted() {
    this.bindAccount()    
  },
  methods: {
    async bindAccount() {
      const query = localStorage.getItem('wxAuthQuery');
      const wxAuthQuery = JSON.parse(query);
      const r = await oaBind({
        openid: wxAuthQuery.openid,
        wx_app_id: wxAuthQuery.wx_app_id,
        code: this.$route.query.code,
        appkey: wxAuthQuery.appkey,
      })
      this.href = r.content.jump_link;
    }
  },
  components: {},
};
</script>
<style scoped lang="scss">
.href {
  display: block;
  width: 200px;
  height: 200px;
  margin: 50px auto 0;
}
.icon {
  display: block;
  width: 30px;
  height: 30px;
  margin: 20px auto;
}
p {
  text-align: center;
}
</style>
